module.exports = __webpack_public_path__ + "img/Pista_34.b7d45971.png";